import {SVG} from "@svgdotjs/svg.js";
import {drawChar} from "@/components/cyphers/helpers/drawHebrew";
import {keyedAlphabet, missingCharAlphabet, missingCharKeydAlphabet} from "@/components/cyphers/helpers/stringHelpers";
import {drawChar as drawChinaseChar} from "@/components/cyphers/helpers/drawChinase";

export function line(canvas, fromX, fromY, toX, toY, width = 2, color = '#000000') {
// let line =
    canvas.line(fromX, fromY, toX, toY).stroke({width, color})//, dasharray: '5,5'
    // line
}

export function drawPolyline(canvas, path, width = 2) { // path = [0,0, 100,50, 50,100]
    canvas.polyline(path).fill('none').stroke({color: '#000000', width})
}

//drawDot(draw, padding+(height/2),padding+(width/2),2)
export function drawDot(canvas, height, width, padding, count = 1) {
    switch (count) {
        case 1:
            canvas.circle(15).fill('#000').move(width - padding, height);
            break;
        case 2:
            canvas.circle(15).fill('#000').move(((width - 20) / 2) + 2 * padding, height);
            canvas.circle(15).fill('#000').move(((width + 20) / 2) + 2 * padding, height);
            break;
    }

}

export function drawHorizontal(canvas, fromX, fromY, length) {
    // let ctx = canvas.getContext("2d");
    // ctx.beginPath();
    // ctx.moveTo(fromX, fromY);
    // ctx.lineTo(fromX+length, fromY);
    // ctx.stroke();
    line(canvas, fromX, fromY, fromX + length, fromY);
}

export function drawVertical(canvas, fromX, fromY, length) {
    // let ctx = canvas.getContext("2d");
    // ctx.beginPath();
    // ctx.moveTo(fromX, fromY);
    // ctx.lineTo(fromX, fromY+length);
    // ctx.stroke();
    line(canvas, fromX, fromY, fromX, fromY + length);
}


const charWidth = 175;
const spaceWidth = 25;


const hebrewWidth = 80;
const hebrewHeight = 70;
const hebrewPadding = 10;

export function drawHebrew(svg, charNumbers) {
    for (let i = 0; i < charNumbers.length; i++) {
        let char = charNumbers[i];
        if (parseInt(char) >= 0) {
            let canvas = SVG().addTo('#canvasSpace').size(hebrewWidth + 2 * hebrewPadding, hebrewHeight + 2 * hebrewPadding)
            canvas.attr('viewBox',`0 0 ${hebrewWidth + 2 * hebrewPadding} ${hebrewHeight + 2 * hebrewPadding}`)
            canvas.attr("width","6.66%")
            canvas.attr("height","auto")
            canvas.attr("style",`max-height: ${hebrewHeight + 2 * hebrewPadding}px; min-width: 40px;`)
            drawChar(canvas, parseInt(char), hebrewWidth, hebrewHeight, hebrewPadding);
        } else {
            let canvas = SVG().addTo('#canvasSpace').size(hebrewWidth * 0.4, hebrewHeight)
            canvas.attr('viewBox',`0 0 ${hebrewWidth * 0.4} ${hebrewHeight}`)
            canvas.attr("width","6.66%")
            canvas.attr("height","auto")
            canvas.attr("style",`max-height: ${hebrewHeight}px; min-width: 40px;`)
        }

    }
}

export function drawHebrewTable(canvas, missing=[], params = [], hasCh = false) {
    canvas.size(10 * hebrewWidth + 4 * hebrewPadding, 4 * hebrewHeight + 2 * hebrewPadding);
    canvas.attr('viewBox',`0 0 ${10 * hebrewWidth + 4 * hebrewPadding} ${4 * hebrewHeight + 2 * hebrewPadding}`) //preserveAspectRatio="meet" viewBox="0 0 400 400"
    canvas.attr("width","100%")
    canvas.attr("height","auto")
    canvas.attr("style","max-height:250px; min-width: 150px;")
    /*<editor-fold desc="Tables draw"> First table*/
    line(canvas, hebrewPadding + hebrewWidth, hebrewPadding, hebrewPadding + hebrewWidth, 3 * hebrewHeight + hebrewPadding)
    line(canvas, hebrewPadding + 2 * hebrewWidth, hebrewPadding, hebrewPadding + 2 * hebrewWidth, 3 * hebrewHeight + hebrewPadding)
    // line(canvas,hebrewPadding+3*hebrewWidth,hebrewPadding, hebrewPadding+3*hebrewWidth,3*hebrewHeight+hebrewPadding)
    line(canvas, hebrewPadding, 1 * hebrewHeight + hebrewPadding, 3 * hebrewWidth + hebrewPadding, 1 * hebrewHeight + hebrewPadding)
    line(canvas, hebrewPadding, 2 * hebrewHeight + hebrewPadding, 3 * hebrewWidth + hebrewPadding, 2 * hebrewHeight + hebrewPadding)

    /* Second table*/
    line(canvas, hebrewWidth * 3 + (hebrewWidth / 2) + hebrewPadding + hebrewWidth, hebrewPadding, hebrewWidth * 3 + (hebrewWidth / 2) + hebrewPadding + hebrewWidth, 3 * hebrewHeight + hebrewPadding)
    line(canvas, hebrewWidth * 3 + (hebrewWidth / 2) + hebrewPadding + 2 * hebrewWidth, hebrewPadding, hebrewWidth * 3 + (hebrewWidth / 2) + hebrewPadding + 2 * hebrewWidth, 3 * hebrewHeight + hebrewPadding)
    // line(canvas,hebrewWidth*3+(hebrewWidth/2) + hebrewPadding+3*hebrewWidth,hebrewPadding, hebrewWidth*3+(hebrewWidth/2) + hebrewPadding+3*hebrewWidth,3*hebrewHeight+hebrewPadding)
    line(canvas, hebrewWidth * 3.5 + hebrewPadding, 1 * hebrewHeight + hebrewPadding, hebrewWidth * 3.5 + 3 * hebrewWidth + hebrewPadding, 1 * hebrewHeight + hebrewPadding)
    line(canvas, hebrewWidth * 3.5 + hebrewPadding, 2 * hebrewHeight + hebrewPadding, hebrewWidth * 3.5 + 3 * hebrewWidth + hebrewPadding, 2 * hebrewHeight + hebrewPadding)
    drawDot(canvas, 3.5 * hebrewHeight, 5 * hebrewWidth + hebrewPadding, hebrewPadding, 1)

    /* Third table*/
    line(canvas, hebrewWidth * 7 + hebrewPadding + hebrewWidth, hebrewPadding, hebrewWidth * 7 + hebrewPadding + hebrewWidth, 3 * hebrewHeight + hebrewPadding)
    line(canvas, hebrewWidth * 7 + hebrewPadding + 2 * hebrewWidth, hebrewPadding, hebrewWidth * 7 + hebrewPadding + 2 * hebrewWidth, 3 * hebrewHeight + hebrewPadding)
    // line(canvas,hebrewWidth*8 + hebrewPadding+3*hebrewWidth,hebrewPadding, hebrewWidth*6+(hebrewWidth) + hebrewPadding+3*hebrewWidth,3*hebrewHeight+hebrewPadding)
    line(canvas, hebrewWidth * 7 + hebrewPadding, 1 * hebrewHeight + hebrewPadding, hebrewWidth * 7 + 3 * hebrewWidth + hebrewPadding, 1 * hebrewHeight + hebrewPadding)
    line(canvas, hebrewWidth * 7 + hebrewPadding, 2 * hebrewHeight + hebrewPadding, hebrewWidth * 7 + 3 * hebrewWidth + hebrewPadding, 2 * hebrewHeight + hebrewPadding)
    drawDot(canvas, 3.5 * hebrewHeight, 16.5 * hebrewWidth + hebrewPadding, hebrewPadding, 2)
    /*</editor-fold..>*/
    let alphabet = keyedAlphabet((params[1] || "").replaceAll(/[^a-zA-Z]/gm, ''), true);
    for (let g = 0; g < 3; g++) {
        let XShift = (g * 3.5 * hebrewWidth) + (hebrewWidth / 2);
        for (let i = 0; i < 9; i++) {
            let xxshift = (i % 3) * hebrewWidth;
            let yShift = i < 3 ? 0 * hebrewHeight : i < 6 ? 1 * hebrewHeight : 2 * hebrewHeight;
            canvas.plain(alphabet[(g * 9) + i].replace('*', 'Ch')).attr('style', "font-size: 2.5em;font-family: monospace; ").x(XShift + xxshift).y(yShift + (hebrewHeight / 3));
        }
    }

}

const chinaseWidth = 70;
const chinaseHeight = 70;
const chinasePadding = 25;

export function drawChinase(svg, lineCounts) {
    // let baseX = spaceWidth;
    // let baseY = spaceWidth;
    for (let i = 0; i < lineCounts.length; i++) {
        //let char = lineCounts[i]
        let vertical = lineCounts[i][0];
        let horizontal = lineCounts[i][1];
        let canvas = SVG().addTo('#canvasSpace').size(chinaseWidth + 2 * chinasePadding, chinaseHeight + 2 * chinasePadding)
        canvas.attr('viewBox',`0 0 ${chinaseWidth + 2 * chinasePadding} ${chinaseHeight + 2 * chinasePadding}`)
        canvas.attr("width","6.66%")
        canvas.attr("height","auto")
        canvas.attr("style",`max-height: ${chinaseHeight + 2 * chinasePadding}px; min-width: 40px;`)
        drawChinaseChar(canvas, [horizontal, vertical], chinaseWidth, chinaseHeight, chinasePadding)
    }

}

export function drawChinaseTable(canvas, missing=[], params = [], hasCh = false) {
    
    /*<editor-fold desc="Chinase table draw ... ">*/

    canvas.size(5 * chinaseWidth + 2 * chinasePadding, 5 * chinaseHeight + 2 * chinasePadding);
    // canvas.attr('id','svgDecypherTable')
    canvas.attr('viewBox',`0 0 ${5 * chinaseWidth + 2 * chinasePadding} ${5 * chinaseHeight + 2 * chinasePadding}`) //preserveAspectRatio="meet" viewBox="0 0 400 400"
    canvas.attr("width","100%")
    canvas.attr("height","auto")
    canvas.attr("style","max-height:250px; min-width: 150px;")
    line(canvas, chinasePadding + 0 * chinaseWidth, chinasePadding, chinasePadding + 0 * chinaseWidth, 5 * chinaseHeight + chinasePadding)
    line(canvas, chinasePadding + 1 * chinaseWidth, chinasePadding, chinasePadding + 1 * chinaseWidth, 5 * chinaseHeight + chinasePadding)
    line(canvas, chinasePadding + 2 * chinaseWidth, chinasePadding, chinasePadding + 2 * chinaseWidth, 5 * chinaseHeight + chinasePadding)
    line(canvas, chinasePadding + 3 * chinaseWidth, chinasePadding, chinasePadding + 3 * chinaseWidth, 5 * chinaseHeight + chinasePadding)
    line(canvas, chinasePadding + 4 * chinaseWidth, chinasePadding, chinasePadding + 4 * chinaseWidth, 5 * chinaseHeight + chinasePadding)
    line(canvas, chinasePadding + 5 * chinaseWidth, chinasePadding, chinasePadding + 5 * chinaseWidth, 5 * chinaseHeight + chinasePadding)
    // line(canvas,chinasePadding+3*chinaseWidth,chinasePadding, chinasePadding+3*chinaseWidth,3*chinaseHeight+chinasePadding)
    line(canvas, chinasePadding, 0 * chinaseHeight + chinasePadding, 5 * chinaseWidth + chinasePadding, 0 * chinaseHeight + chinasePadding)
    line(canvas, chinasePadding, 1 * chinaseHeight + chinasePadding, 5 * chinaseWidth + chinasePadding, 1 * chinaseHeight + chinasePadding)
    line(canvas, chinasePadding, 2 * chinaseHeight + chinasePadding, 5 * chinaseWidth + chinasePadding, 2 * chinaseHeight + chinasePadding)
    line(canvas, chinasePadding, 3 * chinaseHeight + chinasePadding, 5 * chinaseWidth + chinasePadding, 3 * chinaseHeight + chinasePadding)
    line(canvas, chinasePadding, 4 * chinaseHeight + chinasePadding, 5 * chinaseWidth + chinasePadding, 4 * chinaseHeight + chinasePadding)
    line(canvas, chinasePadding, 5 * chinaseHeight + chinasePadding, 5 * chinaseWidth + chinasePadding, 5 * chinaseHeight + chinasePadding)
    /*</editor-fold >*/
    
    let alphabet = missingCharKeydAlphabet(params[1] || "", missing, hasCh)
    for (let g = 0; g < 5; g++) {
        let XShift = (g * 3.5 * chinaseWidth) + (chinaseWidth / 2);
        for (let i = 0; i < 5; i++) {
            let xxshift = (i % 5) * chinaseWidth;
            let yShift = g  * chinaseHeight;
            canvas.plain((alphabet[(g * 5) + i]||"").replace('*', 'Ch'))
                .attr('style', "font-size: 2.5em; font-family: monospace; ")
                .x(0.7*chinasePadding+(0.5*chinaseWidth)+xxshift )// XShift+
                .y(yShift + (chinaseHeight / 2))//
        }
    }
}

export default {drawChinase, drawHebrew, drawPolyline};//